module.exports = __webpack_public_path__ + "static/img/1.e11d0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/1.png
// module id = hz0N
// module chunks = 0